export default __webpack_public_path__ + "static/media/D6 - Family Reunification.7468edbb.jpg";